module.exports = __webpack_public_path__ + "static/media/cheellart-title.5027ce27.gif";